import Colors from '@dynatrace/strato-design-tokens/colors';

import {
  getRectPerimeterLines,
  type RectLimits,
} from './utils/get-rect-perimeter-lines.js';
import type { RectDataPoint } from '../../types/data-point.js';
import { RectPerimeterCanvas } from '../canvas/components/RectPerimeterCanvas.js';

interface RectPointCanvasProps {
  point: RectDataPoint;
  conditions: RectLimits;
  width: number;
  height: number;
}

/**
 * Component for rendering a single dataPoint or a group of dataPoints.
 */
export const RectPointCanvas = (props: RectPointCanvasProps) => {
  const { point, width, height, conditions } = props;

  const linesToDraw = getRectPerimeterLines(point, width, height, conditions);

  return (
    <RectPerimeterCanvas
      lines={linesToDraw}
      borderWidth={1}
      opacity={1}
      color={Colors.Text.Neutral.Default}
    />
  );
};
